import {
	GET_PRODUCT_SUMMARY_REQUEST,
	GET_PRODUCT_SUMMARY_SUCCESS,
	GET_PRODUCT_SUMMARY_ERROR
} from 'actions/productSummaryActions';
import { PRODUCT_SIMILAR_RECO_SUCCESS, PRODUCT_CROSS_VERTICAL_MULTI_SUCCESS } from 'actions/productRecoAction';
import { PRODUCT_DETAIL_SUCCESS } from 'actions/productDetailsActions';
import { LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';

import get from 'lodash/get';

export default function productSummary(state = {}, action = null) {
	let pids;
	switch (action.type) {
		case GET_PRODUCT_SUMMARY_REQUEST:
			pids = action.products.reduce((pidObj, product) => {
				return {
					...pidObj,
					[product.productId]: { asyncStatus: LOADING }
				};
			}, {});
			return { ...state, ...pids };

		case GET_PRODUCT_SUMMARY_SUCCESS:
			const responsePids = Object.keys(action.data);
			const missingPids = action.products
				.map(product => product.productId)
				.filter(pid => responsePids.indexOf(pid) === -1);
			pids = responsePids.reduce((pidObj, pid) => {
				return {
					...pidObj,
					[pid]: {
						...action.data[pid],
						asyncStatus: SUCCESS
					}
				};
			}, {});
			if (missingPids.length) {
				pids = missingPids.reduce((pidObj, pid) => {
					return {
						...pidObj,
						[pid]: { asyncStatus: ERROR }
					};
				}, pids);
			}
			return {
				...state,
				asyncStatus: SUCCESS,
				...pids
			};

		case GET_PRODUCT_SUMMARY_ERROR:
			pids = action.products.reduce((pidObj, product) => {
				return {
					...pidObj,
					[product.productId]: { asyncStatus: ERROR, ...action.error }
				};
			}, {});

			return {
				...state,
				asyncStatus: ERROR,
				...pids
			};

		case PRODUCT_CROSS_VERTICAL_MULTI_SUCCESS:
		case PRODUCT_SIMILAR_RECO_SUCCESS:
			return { ...state, ...mapRecoToSummary(action.data) };

		case PRODUCT_DETAIL_SUCCESS:
			const products = (get(action.data, ['product_attach_1', 'data', 0, 'value', 'products']) || []).map(p => ({
				[get(p, ['value', 'id'])]: p
			}));

			return { ...state, ...reduceArrayToMap(products) };

		default:
			return state;
	}
}

// helper `pure` functions
function mapRecoToSummary(reco = {}) {
	const productArray = Object.keys(reco).map(k => ({ [get(reco, [k, 'value', 'id'])]: reco[k] }));
	return reduceArrayToMap(productArray);
}

function reduceArrayToMap(arr = []) {
	return arr.reduce((prev, curr = {}) => {
		const [pid] = Object.keys(curr);
		if (pid) prev[pid] = curr[pid];
		return prev;
	}, {});
}
